import { cartHeaderStyles } from "@insite/content-library/Widgets/Cart/CartHeader";

cartHeaderStyles.gridItem1 = {
    width: 6,
};

cartHeaderStyles.gridItem2 = {
    width: 6,
};